<template>
  <v-container grid-list-md class="pa-5">
    <m-breadcrum :items="bread"></m-breadcrum>
    <v-row>
      <v-col cols="12">
        <m-card title="Detail Kelas">
          <v-tabs show-arrows grow v-model="tabDetil">
            <v-tab v-for="item in itemDetils" :key="item.tab">{{ item.tab }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabDetil">
            <v-tab-item>
              <v-row wrap>
                <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pr-2 text-center">
                  <v-card text color="#fff" flat>
                    <v-container fill-height container--fluid>
                      <v-row fill-height>
                        <v-col class="text-center" cols="12" align-end colbox>
                          <img
                            height="200"
                            src="https://cdn.siap.id/s3/asset illustrasi/Illustrasi/bg-default.png"
                            alt="avatar"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="9" md="9" lg="9" xl="9">
                  <v-list>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text">Nama Kelas</v-list-item-subtitle>
                            <div class="primary--text title">
                              {{ pVal(kelas, "nama") }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text">Deskripsi</v-list-item-subtitle>
                            <div class="black--text">
                              {{ pVal(kelas, "keterangan") }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list>
                  <v-list>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text">Mata Pelajaran</v-list-item-subtitle>
                            <h3 class="primary--text font-weight-bold">
                              {{ pVal(kelas.mapel, "keterangan") }}
                            </h3>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text">Tanggal Mulai Kelas</v-list-item-subtitle>
                            <div class="">
                              {{ pVal(kelas, "tanggal_mulai") | toDT }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text"
                              >Tanggal Selesai Kelas</v-list-item-subtitle
                            >
                            <div class="">
                              {{ pVal(kelas, "tanggal_selesai") | toDT }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list>
                  <v-list>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text"
                              >Batas Pendaftaran Peserta</v-list-item-subtitle
                            >
                            <div class="">
                              {{ pVal(kelas.diklat, "mulai_set_peserta") | toDT }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text"
                              >Batas Pendaftaran Peserta</v-list-item-subtitle
                            >
                            <div class="">
                              {{ pVal(kelas.diklat, "selesai_set_peserta") | toDT }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text"
                              >Batas Pendaftaran Non Peserta</v-list-item-subtitle
                            >
                            <div class="">
                              {{ pVal(kelas.diklat, "mulai_set_admin_lms") | toDT }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text"
                              >Batas Pendaftaran Non Peserta</v-list-item-subtitle
                            >
                            <div class="">
                              {{ pVal(kelas.diklat, "selesai_set_admin_lms") | toDT }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list>
                  <v-list>
                    <v-divider class="mx-4 my-4"></v-divider>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0" v-for="item in items" :key="item.key">
                        <v-list-item>
                          <v-list-item-content>
                            <div class="caption">Jumlah Maksimal {{ item.tab }}</div>
                            <div class="primary--text">
                              {{ findMax(item) }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                    <!--                    <v-row>-->
                    <!--                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">-->
                    <!--                        <v-list-item>-->
                    <!--                          <v-list-item-content>-->
                    <!--                            <div class="caption">Jumlah Maksimal Peserta</div>-->
                    <!--                            <div class="primary&#45;&#45;text">-->
                    <!--                              {{ kelas.max_peserta == 0 ? "Tidak terbatas" : kelas.max_peserta }}-->
                    <!--                            </div>-->
                    <!--                          </v-list-item-content>-->
                    <!--                        </v-list-item>-->
                    <!--                      </v-col>-->
                    <!--                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">-->
                    <!--                        <v-list-item>-->
                    <!--                          <v-list-item-content>-->
                    <!--                            <div class="caption">Jumlah Maksimal Instruktur</div>-->
                    <!--                            <div class="primary&#45;&#45;text">-->
                    <!--                              {{ kelas.max_instruktur == 0 ? "Tidak terbatas" : kelas.max_instruktur }}-->
                    <!--                            </div>-->
                    <!--                          </v-list-item-content>-->
                    <!--                        </v-list-item>-->
                    <!--                      </v-col>-->
                    <!--                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">-->
                    <!--                        <v-list-item>-->
                    <!--                          <v-list-item-content>-->
                    <!--                            <div class="caption">-->
                    <!--                              Jumlah Maksimal Instruktur (Data dari NS)-->
                    <!--                            </div>-->
                    <!--                            <div class="primary&#45;&#45;text">-->
                    <!--                              {{ kelas.max_narasumber == 0 ? "Tidak terbatas" : kelas.max_narasumber }}-->
                    <!--                            </div>-->
                    <!--                          </v-list-item-content>-->
                    <!--                        </v-list-item>-->
                    <!--                      </v-col>-->
                    <!--                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">-->
                    <!--                        <v-list-item>-->
                    <!--                          <v-list-item-content>-->
                    <!--                            <div class="caption">Jumlah Maksimal Fasilitator</div>-->
                    <!--                            <div class="primary&#45;&#45;text">-->
                    <!--                              {{ kelas.max_fasilitator == 0 ? "Tidak terbatas" : kelas.max_fasilitator }}-->
                    <!--                            </div>-->
                    <!--                          </v-list-item-content>-->
                    <!--                        </v-list-item>-->
                    <!--                      </v-col>-->
                    <!--                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">-->
                    <!--                        <v-list-item>-->
                    <!--                          <v-list-item-content>-->
                    <!--                            <div class="caption">-->
                    <!--                              Jumlah Maksimal Pendamping-->
                    <!--                            </div>-->
                    <!--                            <div class="primary&#45;&#45;text">-->
                    <!--                              {{ kelas.max_pendamping == 0 ? "Tidak terbatas" : kelas.max_pendamping }}-->
                    <!--                            </div>-->
                    <!--                          </v-list-item-content>-->
                    <!--                        </v-list-item>-->
                    <!--                      </v-col>-->
                    <!--                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">-->
                    <!--                        <v-list-item>-->
                    <!--                          <v-list-item-content>-->
                    <!--                            <div class="caption">Jumlah Maksimal Admin LMS</div>-->
                    <!--                            <div class="primary&#45;&#45;text">-->
                    <!--                              {{ kelas.max_adminlms == 0 ? "Tidak terbatas" : kelas.max_adminlms }}-->
                    <!--                            </div>-->
                    <!--                          </v-list-item-content>-->
                    <!--                        </v-list-item>-->
                    <!--                      </v-col>-->
                    <!--                    </v-row>-->
                  </v-list>
                  <v-list>
                    <v-row>
                      <v-col cols="12" md="6" class="py-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="caption grey--text">Status</v-list-item-subtitle>
                            <span :class="kelas.is_lengkap ? 'title success--text' : 'title orange--text'">{{
                              kelas.is_lengkap == 0 ? "Belum Tersinkron" : "Tersinkron"
                            }}</span>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" v-if="kelas && !kelas.is_lengkap">
                  <v-alert type="info">
                    Peserta dan Admin hanya dapat di isi jika kelas sudah ter-sinkron. Pastikan anda menekan tombol
                    <b>Sinkron Kelas</b> terlebih dahulu.
                  </v-alert>
                </v-col>
                <v-col cols="12"> </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="12">
                  <m-alert
                    show
                    title="Menu Kelola Pengguna"
                    info="<strong>Menu Kelola Pengguna</strong> digunakan untuk meakukan pengelolaan pengguna dalam kelas. Pilih tab peran pengguna untuk melakukan kelola pada setiap peran kelas."
                  ></m-alert>
                </v-col>
                <v-col cols="12">
                  <v-tabs show-arrows grow v-model="tab">
                    <v-tab v-for="item in items" :key="item.tab">{{ item.tab }}</v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab">
                    <div v-if="kelas && kelas.tab">
                      <v-tab-item v-for="peran in kelas.tab" :key="peran.index">
                        <v-card flat>
                          <v-card-text>
                            <ListTable
                              :addData="isCan('enrol') && peran.is_enrol"
                              :items="kelas[peran.att]"
                              :tipe="peran.grup_id"
                              @load="loadEnroll"
                            />
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </div>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>
              <v-card class="pa-4 my-4 elevation-0" outlined v-for="modul in kelasmodul" :key="modul.id">
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <p class="title primary--text my-0 py-0">{{ modul.nama }}</p>
                    <v-chip small label :color="modul.created == 1 ? 'success' : 'error'">{{
                      modul.created == 1 ? "Konten Tersedia" : "Konten Belum Tersedia"
                    }}</v-chip>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                    :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'"
                  >
                    <m-button
                      v-if="current_user.is_super_admin"
                      right
                      :small="$vuetify.breakpoint.smAndDown ? true : false"
                      class="my-2"
                      color="success white--text"
                      textButton="Tautan LMS"
                      icon="mdi-link"
                      action="toLMS"
                      @toLMS="toLMS(modul)"
                    ></m-button>
                    <!-- <m-button
                      right
                      :small="$vuetify.breakpoint.smAndDown ? true : false"
                      class="my-2"
                      color="primary white--text"
                      text="Pengelompokan"
                      icon="mdi-plus"
                      action="add"
                      :disabled="modul.gruping.length >= $consts.BATAS_GROUPING"
                      @add="add(modul.id)"
                    ></m-button> -->
                  </v-col>
                  <!-- <v-col cols="12">
                    <m-alert
                      show
                      type="info"
                      info="Jumlah Maksimal Pengelompokan dalam 1 Kelas adalah 4 Pengelompokan (4 Grouping)"
                    ></m-alert>
                  </v-col> -->
                </v-row>
                <!-- <v-divider></v-divider> -->
                <ListGroup :items="modul.gruping" @load="loadGrup" />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </m-card>
      </v-col>
    </v-row>
    <ChangeDlg ref="dlg" />
    <ChangeGroupingDlg ref="dlgGrouping" />
  </v-container>
</template>
<script>
import ListTable from "../../enroll/components/ListTable.vue";
import ListGroup from "../../kelas/components/ListGroup.vue";
import ChangeDlg from "../../enroll/components/Form.vue";
import ChangeGroupingDlg from "../../kelas/components/FormGrouping.vue";
export default {
  components: {
    ListTable,
    ListGroup,
    ChangeDlg,
    ChangeGroupingDlg
  },
  data() {
    return {
      jenisDiklat: [],
      kelas: {
        tab: []
      },
      tab: 3,
      tabDetil: null,
      tabDetils: 3,
      itemDetils: [],
      items: []
    };
  },
  activated() {
    this.loadEnroll();
    this.loadGrup();
  },
  methods: {
    findMax(data) {
      return this.kelas[data.max_attribute];
    },

    setTab(res) {
      var tabs = [];
      res.tab.forEach(item => {
        var tab = {
          tab: item.label,
          max_attribute: item.max_attribute,
          content: item.label,
          id: item.grup_id
        };
        tabs.push(tab);
      });
      this.items = [...tabs];
      this.$nextTick(() => {
        this.tab = tabs.findIndex(x => x.id == 8);
      });
    },
    add(kelas_modul_id) {
      this.$refs.dlgGrouping.open({}, kelas_modul_id).then(() => {
        this.loadEnroll();
        this.loadGrup();
      });
    },
    loadEnroll() {
      return this.$store
        .dispatch("enroll/detail", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          enroll_id: this.$route.params.kelas_id
        })
        .then(res => {
          this.kelas = res;
          this.setTab(res);
        })
        .catch(e => e);
    },
    loadGrup() {
      return this.$store
        .dispatch("kelas/getGrup", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          kelas_id: this.$route.params.kelas_id
        })
        .catch(e => e);
    },
    toLMS(val) {
      window.open(val.link_moodle, "_blank");
    }
  },
  computed: {
    bread() {
      return [
        {
          icon: "mdi-library-books",
          title: "Kelola Kelas",
          to: {
            name: "kelas",
            params: { instansi_id: this.instansi_id, diklat_id: this.diklat_id }
          }
        },
        {
          icon: "mdi-edit",
          title: this.kelas ? this.kelas.nama : "-"
        }
      ];
    },
    kelasmodul() {
      return this.$store.getters["kelas/grouping"];
    }
  },
  watch: {
    kelas(n) {
      if (n && this.current_user.is_super_admin) {
        this.tabDetils = 3;
        this.itemDetils = [
          { tab: "Informasi Kelas", content: "Informasi Kelas" },
          { tab: "Kelola Pengguna", content: "Kelola Pengguna" },
          { tab: "Modul", content: "Modul" }
        ];
      } else {
        this.tabDetils = 2;
        this.itemDetils = [
          { tab: "Informasi Kelas", content: "Informasi Kelas" },
          { tab: "Kelola Pengguna", content: "Kelola Pengguna" }
        ];
      }
    }
  }
};
</script>
